export default __webpack_public_path__ + "static/media/robot-face-icon.b1e338c8.png";